import React from 'react';
import { CtaBlock } from '../CtaBlock';
import { PRODUCT_IMAGE } from '../../data/content';
export function FinalCta() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-98" data-mp="22dclk26wy70o">
      <div className="mx-auto max-w-2xl text-center" data-id="element-99" data-mp="1nphtmo0qc6on">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-arc-400" data-id="element-100" data-mp="1nmvmuqlnxv7h">
          La prochaine fois que vous allumerez votre poste à souder…
        </p>
        <h2 className="mt-3 text-balance font-display text-3xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-101" data-mp="1eniclvppt2lp">
          Vous pouvez continuer à improviser…
          <span className="mt-2 block text-spark-400" data-id="element-102" data-mp="14qnal2u8gk2o">
            Ou commencer avec la sécurité de savoir exactement quoi faire.
          </span>
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/70" data-id="element-103" data-mp="19rb3xv5xpd02">
          Ouvrez le Système Maître de Soudage™, consultez la configuration adaptée à votre
          situation et commencez à souder avec davantage de précision, de confiance et des
          résultats qui paraissent réellement professionnels.
        </p>

        <img src={PRODUCT_IMAGE} alt="Système Maître de Soudage™ — pack complet" className="mx-auto mt-7 w-full max-w-sm" data-id="element-104" data-mp="3tg7o0st8we0a" />

        <p className="mt-4 font-display text-3xl font-bold uppercase text-spark-400" data-id="element-105" data-mp="b39hg31y6mx5">
          19 € en un seul paiement
        </p>

        <div className="mt-6" data-id="element-106" data-mp="3fev82he34cee">
          <CtaBlock label="Je veux le Système Maître de Soudage" note="Accès immédiat · Accès à vie · Garantie de 7 jours" data-id="element-107" data-mp="3fg6l77tf6wi6" />
        </div>
      </div>
    </section>;
}